"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingStep = exports.RegistrationType = exports.aiInstructionFilterMap = exports.aiInstructionSortMap = exports.personalAccessTokenListSortMap = exports.MCP_ACCESS_SCOPES = exports.MCP_DEFAULT_ACCESS_SCOPE = exports.GENERAL_DEFAULT_ACCESS_SCOPE = exports.PersonalAccessTokenScope = exports.PersonalAccessTokenUsage = exports.serviceTokenFilterMap = exports.serviceTokensSortMap = exports.DISK_SPACE_PATH_PATTERN = exports.DISK_SPACE_PATH_MAX_LENGTH = exports.KeyType = exports.ContainerType = exports.LoginType = exports.UserRole = exports.UserStatus = void 0;
var UserStatus;
(function (UserStatus) {
    UserStatus["Active"] = "active";
    UserStatus["Inactive"] = "inactive";
    UserStatus["Incomplete"] = "incomplete";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
var UserRole;
(function (UserRole) {
    UserRole["User"] = "user";
    UserRole["Admin"] = "admin";
    UserRole["Guest"] = "guest";
})(UserRole || (exports.UserRole = UserRole = {}));
var LoginType;
(function (LoginType) {
    LoginType["PASSWORD"] = "password";
    LoginType["OTHER"] = "other";
})(LoginType || (exports.LoginType = LoginType = {}));
var ContainerType;
(function (ContainerType) {
    ContainerType["Docker"] = "docker";
    ContainerType["Singularity"] = "singularity";
})(ContainerType || (exports.ContainerType = ContainerType = {}));
var KeyType;
(function (KeyType) {
    KeyType["Cluster"] = "clu";
    KeyType["AmazonPrivate"] = "amz_pri";
    KeyType["AmazonPublic"] = "amz_pub";
    KeyType["SSHPrivate"] = "ssh_pri";
    KeyType["SSHPublic"] = "ssh_pub";
})(KeyType || (exports.KeyType = KeyType = {}));
exports.DISK_SPACE_PATH_MAX_LENGTH = 1024;
exports.DISK_SPACE_PATH_PATTERN = /^[A-Za-z0-9._\-/~+@,=:]*$/;
exports.serviceTokensSortMap = {
    name: "st.name",
    tokenType: "st.type",
    ownerEmail: "u.email",
    createdAt: "st.date_created",
    updatedAt: "st.date_modified",
};
exports.serviceTokenFilterMap = {
    id: "st.id",
    name: "st.name",
    tokenType: "st.type",
    ownerEmail: "u.email",
    createdAt: "st.date_created",
    updatedAt: "st.date_modified",
    selected: "(stu.id IS NOT NULL)",
};
var PersonalAccessTokenUsage;
(function (PersonalAccessTokenUsage) {
    PersonalAccessTokenUsage["General"] = "general";
    PersonalAccessTokenUsage["MCP"] = "mcp";
})(PersonalAccessTokenUsage || (exports.PersonalAccessTokenUsage = PersonalAccessTokenUsage = {}));
var PersonalAccessTokenScope;
(function (PersonalAccessTokenScope) {
    PersonalAccessTokenScope["Read"] = "read";
    PersonalAccessTokenScope["Write"] = "write";
    PersonalAccessTokenScope["Admin"] = "admin";
})(PersonalAccessTokenScope || (exports.PersonalAccessTokenScope = PersonalAccessTokenScope = {}));
exports.GENERAL_DEFAULT_ACCESS_SCOPE = PersonalAccessTokenScope.Read;
exports.MCP_DEFAULT_ACCESS_SCOPE = PersonalAccessTokenScope.Read;
exports.MCP_ACCESS_SCOPES = [
    PersonalAccessTokenScope.Read,
    PersonalAccessTokenScope.Write,
];
exports.personalAccessTokenListSortMap = {
    name: "pat.name",
    createdAt: "pat.created_at",
    expiresAt: "pat.expires_at",
};
exports.aiInstructionSortMap = {
    name: "name",
    createdAt: "created_at",
};
exports.aiInstructionFilterMap = {
    id: "id",
    name: "name",
    createdAt: "created_at",
};
var RegistrationType;
(function (RegistrationType) {
    RegistrationType["Self"] = "self";
    RegistrationType["Invitation"] = "invitation";
    RegistrationType["Guest"] = "guest";
    RegistrationType["UrlSignup"] = "url_signup";
})(RegistrationType || (exports.RegistrationType = RegistrationType = {}));
var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep["AccountCreated"] = "account_created";
    OnboardingStep["AgreementsAccepted"] = "agreements_accepted";
    OnboardingStep["PaymentCompleted"] = "payment_completed";
    OnboardingStep["OrganizationCreated"] = "organization_created";
})(OnboardingStep || (exports.OnboardingStep = OnboardingStep = {}));
